import { useTranslation } from "react-i18next";
import CardLink from "Components/CardLink/CardLink";

//Icons
import approvalDelegation from "../../../Assets/icons/enviroment/approval_delegation.svg";
import captivePortal from "Assets/icons/enviroment/captive_portal.svg";
import engineering from "Assets/icons/enviroment/engineering.svg";
import groups from "Assets/icons/enviroment/groups.svg";
import handyman from "Assets/icons/enviroment/handyman.svg";
import arrowBtn from "Assets/icons/arrow_left.svg";

//Files
//import dossier2025 from "Assets/files/dossier-2025.pdf";
import dossier from "Assets/files/Dossier-Baipro-2026.pdf";

//styles
import "../Landing.scss";
import { trackEvent } from "Services/Analytics/trackEvent";

const Future = () => {
  const { t } = useTranslation();

  const handleDownload = () => {
    trackEvent("dossier_download");
    setTimeout(() => {
      const link = document.createElement("a");
      link.href = dossier;
      link.download = t("future.fileName");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }, 500);
  };

  return (
    <section className="section landing-section relative-section" id="future">
      <div className="background"></div>
      <div className="content">
        <h2 className="title">{t("future.title")}</h2>
        <p className="description">
          {t("future.text1")}{" "}
          <mark className="mark-sky">{t("future.mark1")}</mark>{" "}
          {t("future.text2")}{" "}
          <mark className="mark-sky">{t("future.mark2")}</mark>
          <br />
          <br />
          {t("future.text3")}{" "}
          <mark className="mark-sky">{t("future.mark3")}</mark>{" "}
          {t("future.text4")}
        </p>
        <button
          onClick={handleDownload}
          className="button"
          aria-label={t("future.button")}
        >
          <img src={arrowBtn} width={24} height={24} alt="arrow rigth" />
          {t("future.button")}
        </button>
      </div>
      <div className="future-cardlinks">
        <CardLink
          title={t("future.services1")}
          img={approvalDelegation}
          background="sky"
          navigateTo="/services"
          elementId="epc"
          eventName="epc_button"
        />
        <CardLink
          title={t("future.services2")}
          img={handyman}
          background="sky"
          navigateTo="/services"
          elementId="construction"
          eventName="construccion_button"
        />
        <CardLink
          title={t("future.services3")}
          img={engineering}
          background="sky"
          navigateTo="/services"
          elementId="engineering"
          eventName="ingenieria_button"
        />
        <CardLink
          title={t("future.services4")}
          img={groups}
          background="sky"
          navigateTo="/services"
          elementId="staff"
          eventName="provsision_personal_button"
        />
        <CardLink
          title={t("future.services5")}
          img={captivePortal}
          background="blue"
          navigateTo="https://neocomplexx.com/"
          elementId="software"
          eventName="software_button"
        />
      </div>
    </section>
  );
};

export default Future;
